module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "refund-payment-row",
    class: {
      'refund-payment-row--selectable': _vm.selectable,
      'refund-payment-row--selected': _vm.selected,
      'refund-payment-row--plain': _vm.plain,
    },
    on: {
      "click": function($event) {
        _vm.selectable && _vm.$emit('select')
      }
    }
  }, [(_vm.selectable) ? _c('span', {
    staticClass: "refund-payment-row__radio mr-3",
    class: {
      'refund-payment-row__radio--checked': _vm.selected
    }
  }) : _vm._e(), _vm._v(" "), _c('reference-avatar', {
    staticClass: "mr-3",
    attrs: {
      "reference": _vm.title,
      "index": _vm.index
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "refund-payment-row__info"
  }, [_c('div', {
    staticClass: "refund-payment-row__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "refund-payment-row__subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "refund-payment-row__amount"
  }, [_vm._v(_vm._s(_vm.amountLabel))])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2501aff0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2501aff0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationRefundTransaction/PaymentRow.vue
// module id = 2146
// module chunks = 0